import * as React from "react";
import Library from "../components/Library";
import { Consumer } from "../libs/AuthContext";
import { Redirect } from "@reach/router";

class Home extends React.Component {
 render() {
    return (
      <Consumer>
        {context =>
          (context && context.isAuthenticated) ?
            <div>
              <Library />
            </div>
            :
            <Redirect to={"/login"} noThrow/>
        }
      </Consumer>
    )
  }
}

export default (props => (
  <Consumer>
    {value => <Home {...props} context={value} />}
  </Consumer>
))
